import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-patient-appointment-card',
  templateUrl: './patient-appointment-card.component.html',
  styleUrls: ['./patient-appointment-card.component.css']
})
export class PatientAppointmentCardComponent implements OnInit {

  constructor() { }

  @Input() cases;
  @Output() infoAction = new EventEmitter();
  @Output() noteAction = new EventEmitter();
  @Output() scheduleAction = new EventEmitter();
  
  ngOnInit() {
  }

  getInfo(data) {
    this.infoAction.emit(data);

  }

  getNote(data) {
    this.noteAction.emit(data);

  }

  getSchedule(data) {
    this.scheduleAction.emit(data);
  }

}
